export default "__VITE_ASSET__CS5KshF7__"